$(document).on('line:chart.nearme', function(event, el, values, labels) {
  require.ensure('../charts/chart_wrappers/line', function(require) {
    var LineChart = require('../charts/chart_wrappers/line');
    new LineChart(el, values, labels);
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/linechart.initializer.js